import React from 'react';

const SpcAcademyEntry202601Page: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-slate-50">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center px-6 py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-100/40 to-transparent"></div>
        <div className="relative max-w-4xl mx-auto text-center space-y-12">
          <div className="space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-relaxed">
              スピリアルコンシェルジュアカデミー
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 font-light leading-relaxed">
              ― 表舞台に光をともす、Light Workerという役割 ―
            </p>
            <p className="text-lg md:text-xl text-amber-800 font-bold">
              【審査制・3か月プログラム】
            </p>
          </div>

          <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/c67dfd5c5e523441f091f5e9533b5034.jpg"
              alt="Light Worker Role"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </section>

      {/* About This Page */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            このページについて
          </h2>

          <div className="bg-gradient-to-br from-slate-50 to-white p-10 rounded-2xl border-2 border-slate-300 shadow-lg space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              このページは、<br />
              本日の説明会に参加された方のために用意された<br />
              スピリアルコンシェルジュアカデミーの正式募集案内です。
            </p>
            <p className="font-bold text-gray-900">一般公開はしていません。</p>
            <p>
              説明会でお伝えした内容を前提として、<br />
              その上で<br />
              「次のステージへ進むかどうか」を判断するための資料<br />
              としてお読みください。
            </p>
          </div>
        </div>
      </section>

      {/* Light Workers */}
      <section className="py-20 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            光を放つ人と、光を通す人
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <p className="text-center">
              表舞台に立ち、<br />
              メッセージを届け、<br />
              人の人生に光をともす人がいます。
            </p>

            <p className="text-center">
              けれど、<br />
              その光が歪まず、<br />
              安心して、<br />
              必要な人のもとへ届くためには、<br />
              もう一つの役割が必要です。
            </p>

            <div className="pt-8 pb-4">
              <p className="text-2xl md:text-3xl font-bold text-center text-amber-800">
                それが、<br />光を通すLight Worker。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-12">
              <div className="bg-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">場を整える</p>
              </div>
              <div className="bg-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">流れを止めない</p>
              </div>
              <div className="bg-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">混乱を静める</p>
              </div>
              <div className="bg-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">人が本来の輝きを発揮できる舞台をひらく</p>
              </div>
            </div>

            <p className="text-xl text-center pt-6">
              これは裏方ではありません。<br />
              <span className="font-bold text-gray-900">光が届くための"現実"を担う仕事です。</span>
            </p>
          </div>
        </div>
      </section>

      {/* Dynavision History */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            ダイナビジョンが30年以上続いてきた理由
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed mb-12">
            <p className="text-center">
              ダイナビジョンは、<br />
              30年以上にわたり<br />
              数多くのセミナー、講座、イベントを開催し、<br />
              人の人生が動く瞬間に立ち会ってきました。
            </p>

            <p className="text-center font-bold text-xl text-gray-900">
              それを支えてきたのは、<br />
              言葉やメッセージの力だけではありません。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-12">
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 rounded-xl border border-slate-200 shadow-sm text-center">
              <i className="ri-list-check text-4xl text-slate-700 mb-3 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <p className="text-gray-800 font-bold">段取り</p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 rounded-xl border border-slate-200 shadow-sm text-center">
              <i className="ri-lightbulb-line text-4xl text-slate-700 mb-3 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <p className="text-gray-800 font-bold">判断</p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 rounded-xl border border-slate-200 shadow-sm text-center">
              <i className="ri-shield-check-line text-4xl text-slate-700 mb-3 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <p className="text-gray-800 font-bold">責任</p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 rounded-xl border border-slate-200 shadow-sm text-center">
              <i className="ri-hand-heart-line text-4xl text-slate-700 mb-3 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <p className="text-gray-800 font-bold">信頼</p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 rounded-xl border border-slate-200 shadow-sm text-center">
              <i className="ri-heart-line text-4xl text-slate-700 mb-3 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <p className="text-gray-800 font-bold">安心感</p>
            </div>
          </div>

          <div className="text-center space-y-6">
            <p className="text-xl text-gray-700">
              これらが揃ったとき、<br />
              光は「体験」として現実に届きます。
            </p>
            <p className="text-2xl font-bold text-amber-800">
              その調律を担ってきた存在が、<br />
              スピリアルコンシェルジュです。
            </p>
          </div>
        </div>
      </section>

      {/* Academy Description */}
      <section className="py-20 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            スピリアルコンシェルジュアカデミーとは
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed mb-12">
            <p className="text-xl text-center">
              スピリアルコンシェルジュアカデミーは、<br />
              ダイナビジョンの現場を支える<br />
              Light Workerとしての在り方と実務を育てるためのアカデミーです。
            </p>

            <p className="text-center font-bold text-gray-900">
              ここで扱うのは、<br />
              知識やノウハウではありません。
            </p>
          </div>

          <div className="bg-gradient-to-br from-slate-50 to-white p-10 rounded-2xl border border-slate-300 shadow-lg mb-12">
            <ul className="space-y-4 text-lg text-gray-800">
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>講師と参加者をつなぐ調整力</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>セミナー・LIVE運営の現実</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>イレギュラーが起きたときの判断</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>場のエネルギーを保つ在り方</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>光が止まらないための責任の持ち方</span>
              </li>
            </ul>
          </div>

          <p className="text-xl md:text-2xl text-center font-bold text-gray-900">
            スピリチュアルを、現実で機能させる力を<br />
            3か月かけて身につけていきます。
          </p>
        </div>
      </section>

      {/* Why Screening */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            なぜ「審査制」なのか
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <p className="text-xl text-center font-bold text-gray-900">
              この役割は、<br />
              誰にでも向いているものではありません。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-12">
              <div className="bg-slate-50 p-8 rounded-xl border-2 border-slate-300 shadow-sm">
                <p className="text-gray-800">楽な仕事を求めている</p>
              </div>
              <div className="bg-slate-50 p-8 rounded-xl border-2 border-slate-300 shadow-sm">
                <p className="text-gray-800">指示がないと動けない</p>
              </div>
              <div className="bg-slate-50 p-8 rounded-xl border-2 border-slate-300 shadow-sm">
                <p className="text-gray-800">責任を負いたくない</p>
              </div>
              <div className="bg-slate-50 p-8 rounded-xl border-2 border-slate-300 shadow-sm">
                <p className="text-gray-800">学ぶだけで満足したい</p>
              </div>
            </div>

            <p className="text-center">
              こうした姿勢のまま関わると、<br />
              本人にとっても、<br />
              場にとっても、不幸が生まれます。
            </p>

            <div className="bg-gradient-to-br from-amber-50 to-white p-10 rounded-2xl border-2 border-amber-200 shadow-lg mt-12">
              <p className="text-xl text-center font-bold text-gray-900 mb-4">
                だからこそ、<br />
                スピリアルコンシェルジュアカデミーは<br />
                審査制を採用しています。
              </p>
              <p className="text-center text-amber-800 font-bold text-lg">
                これは選別のためではありません。<br />
                役割と場を守るための仕組みです。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Instructor */}
      <section className="py-20 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            講師紹介
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            <div className="lg:col-span-1">
              <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-lg text-center">
                <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden bg-slate-100">
                  <img 
                    src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/334336b9a391944414d149291891e207.png"
                    alt="浅田善幸"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">浅田善幸</h3>
                <p className="text-gray-700 font-bold">株式会社ダイナビジョン 取締役</p>
              </div>
            </div>

            <div className="lg:col-span-2 space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                浅田善幸は、<br />
                スピリチュアル業界の外から<br />
                この世界に入りました。
              </p>

              <p>
                不動産営業、<br />
                コールセンター運営、<br />
                セミナー業界。
              </p>

              <p>
                一貫して<br />
                人と人の間に立ち、現場を支える仕事を<br />
                20年以上続けてきました。
              </p>

              <p>
                コールセンターでは15年間、<br />
                オペレーターから始まり、<br />
                スーパーバイザー、<br />
                アシスタントマネージャーとして<br />
                現場責任を担いました。
              </p>

              <p>
                2016年よりダイナビジョンに参画し、<br />
                穴口恵子のコンテンツ運営全般を担当。<br />
                セミナー事業部、イベント統括を経て、<br />
                現在は取締役として<br />
                事業・運営の中枢を担っています。
              </p>

              <p className="font-bold text-xl text-gray-900 pt-4">
                ここで伝えるのは、<br />
                理論ではなく<br />
                修羅場をくぐってきた現場判断です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Paid */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            なぜ有料なのか
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <p className="text-xl text-center font-bold text-gray-900">
              このアカデミーは、<br />
              情報提供ではありません。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-12">
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">判断を引き受ける姿勢</p>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">責任を持つ覚悟</p>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">逃げない在り方</p>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <p className="text-gray-800 font-bold">現実と向き合う力</p>
              </div>
            </div>

            <p className="text-center">
              これらは、<br />
              本気で向き合う人にしか渡せないものです。
            </p>

            <div className="bg-gradient-to-br from-amber-50 to-white p-10 rounded-2xl border-2 border-amber-200 shadow-lg mt-12">
              <p className="text-xl text-center font-bold text-gray-900 mb-4">
                お金を払うという行為は、<br />
                「この役割を引き受ける」という<br />
                意思表示でもあります。
              </p>
              <p className="text-center text-amber-800 font-bold text-lg">
                だからこそ、<br />
                このアカデミーは無料では行いません。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Program Overview */}
      <section className="py-20 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            プログラム概要
          </h2>

          <div className="bg-white p-10 rounded-2xl border-2 border-slate-300 shadow-lg mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">期間</h3>
            <p className="text-3xl font-bold text-center text-amber-800">3か月</p>
          </div>

          <div className="bg-gradient-to-br from-slate-50 to-white p-10 rounded-2xl border border-slate-300 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">主な内容</h3>
            <ul className="space-y-4 text-lg text-gray-800">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>ダイナビジョン事務局構造の理解</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>講師対応・スケジュール調整</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>LIVE・セミナー運営フロー</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>トラブル対応と判断の考え方</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-2xl text-slate-700 mr-4 mt-1 w-8 h-8 flex items-center justify-center"></i>
                <span>Light Workerとしての在り方</span>
              </li>
            </ul>
            <p className="text-center mt-8 text-gray-700 italic">
              ※座学ではなく、<br />
              現場視点でのケース共有・実践が中心です。
            </p>
          </div>
        </div>
      </section>

      {/* Future Path */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            この先にひらかれる道
          </h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <p className="text-xl text-center">
              アカデミー修了後、<br />
              審査を通過した方には、
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <i className="ri-building-line text-4xl text-slate-700 mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
                <p className="text-gray-800 font-bold">ダイナビジョン事務局としての実務参加</p>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <i className="ri-briefcase-line text-4xl text-slate-700 mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
                <p className="text-gray-800 font-bold">アルバイト・業務委託・正社員候補</p>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 shadow-sm text-center">
                <i className="ri-team-line text-4xl text-slate-700 mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
                <p className="text-gray-800 font-bold">継続的なプロジェクト参画</p>
              </div>
            </div>

            <p className="text-xl text-center pt-8">
              など、<br />
              Light Workerとして現実社会で光をともす道がひらかれます。
            </p>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-20 px-6 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
            価格
          </h2>

          <div className="bg-white p-10 rounded-2xl border-2 border-amber-300 shadow-2xl">
            <div className="text-center space-y-6">
              <div>
                <p className="text-gray-700 text-lg mb-2">定価</p>
                <p className="text-3xl font-bold text-gray-400 line-through">25万円</p>
              </div>
              <div className="pt-4">
                <p className="text-amber-800 text-xl font-bold mb-3">説明会参加者限定</p>
                <p className="text-5xl md:text-6xl font-bold text-amber-800">12万5千円</p>
              </div>
              <p className="text-sm text-gray-600 italic pt-6">
                ※この価格は割引ではありません。<br />
                覚悟と本気度を確認するための設定です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Suitable / Not Suitable */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
                向いている方
              </h3>
              <div className="bg-gradient-to-br from-amber-50 to-white p-8 rounded-2xl border-2 border-amber-200 shadow-lg space-y-4">
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">表舞台に光をともす仕事を引き受けたい</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">スピリチュアルを現実で体現したい</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">支える役割に誇りを持てる</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">責任ある立場で成長したい</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
                向いていない方
              </h3>
              <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl border-2 border-slate-300 shadow-lg space-y-4">
                <div className="flex items-start">
                  <i className="ri-close-line text-2xl text-slate-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">楽な学びを求めている</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-2xl text-slate-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">指示待ちで関わりたい</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-2xl text-slate-600 mr-3 mt-1 w-8 h-8 flex items-center justify-center"></i>
                  <p className="text-gray-800">単発感覚で考えている</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final Message */}
      <section className="py-20 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto text-center space-y-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">最後に</h2>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <p className="text-xl">
              ここまで読んでくださったあなたは、<br />
              このアカデミーの前提を<br />
              理解している方だと思います。
            </p>

            <div className="bg-white p-10 rounded-2xl border-2 border-slate-300 shadow-lg">
              <p className="text-xl font-bold text-gray-900 mb-4">
                この場は、<br />
                憧れを満たす場所ではありません。
              </p>
              <p className="text-xl font-bold text-amber-800">
                役割を現実として引き受けるかどうかを<br />
                自分に問いかける場所です。
              </p>
            </div>

            <p className="text-2xl font-bold text-gray-900 pt-6">
              進むか、進まないか。<br />
              その判断は、あなたに委ねられています。
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            次のステップ
          </h2>

          <div className="bg-gradient-to-br from-slate-50 to-white p-10 rounded-2xl border-2 border-slate-300 shadow-lg space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              スピリアルコンシェルジュアカデミーへの参加は<br />
              <span className="font-bold text-gray-900">審査制・面談制</span>です。
            </p>
            <p>
              このページを読んだ上で<br />
              「進みたい」と感じた方のみ、<br />
              ご案内しているエントリーフォームより<br />
              審査へお進みください。
            </p>
            <p className="text-sm text-gray-600 italic">
              ※審査通過者のみ、個別面談のご案内を差し上げます<br />
              ※全員が次に進めるわけではありません
            </p>
          </div>

          <a 
            href="#"
            className="inline-block bg-slate-800 hover:bg-slate-900 text-white font-bold text-lg px-12 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer mt-8"
          >
            審査に進む
          </a>
        </div>
      </section>
    </div>
  );
};

export default SpcAcademyEntry202601Page;
